import { initialPortfolio } from './mock/data'
import type { PreviewActions } from './workspace'

type PortfolioField = keyof typeof initialPortfolio

export function createPortfolio(root: HTMLElement, actions: PreviewActions) {
  const page = root.querySelector<HTMLElement>('[data-marketing-page="portfolio"]')!
  const form = page.querySelector<HTMLFormElement>('[data-preview-portfolio-form]')!
  const data = { ...initialPortfolio }
  let section = 'opening'
  let preview = false
  let artFilter = 'all'
  const fields: Record<string, PortfolioField[]> = {
    opening: ['name', 'role', 'headline', 'introduction'],
    works: ['name', 'role', 'headline'],
    statement: ['statement'],
    links: ['linkLabel', 'linkUrl']
  }

  function render() {
    page.querySelectorAll<HTMLElement>('[data-preview-portfolio-text]').forEach((element) => {
      element.textContent = data[element.dataset.previewPortfolioText as PortfolioField]
    })
    page
      .querySelectorAll<HTMLElement>('[data-preview-portfolio-section]')
      .forEach((button) =>
        button.setAttribute('aria-pressed', String(button.dataset.previewPortfolioSection === section))
      )
    page.querySelectorAll<HTMLElement>('[data-preview-portfolio-input-group]').forEach((group) => {
      group.hidden = !fields[section].includes(group.dataset.previewPortfolioInputGroup as PortfolioField)
    })
    for (const key of Object.keys(data) as PortfolioField[]) {
      const input = form.elements.namedItem(key) as HTMLInputElement
      if (document.activeElement !== input) input.value = data[key]
    }
    const sectionTitles: Record<string, string> = {
      opening: 'Exhibition introduction',
      works: 'Featured works',
      statement: 'Artist statement',
      links: 'Header links'
    }
    page.querySelector('[data-preview-portfolio-section-title]')!.textContent = sectionTitles[section]
    page.querySelectorAll<HTMLElement>('[data-preview-art]').forEach((art) => {
      art.hidden = artFilter !== 'all' && art.dataset.previewArt !== artFilter
    })
    page
      .querySelectorAll<HTMLElement>('[data-preview-art-filter]')
      .forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.previewArtFilter === artFilter)))
    page.querySelector('[data-preview-portfolio-preview]')!.textContent = preview ? 'Back to editor' : 'Preview'
    const editor = page.querySelector<HTMLElement>('[data-preview-portfolio-editor]')!
    editor.classList.toggle('grid-cols-[220px_minmax(0,1fr)_300px]', !preview)
    editor.classList.toggle('grid-cols-1', preview)
    editor.querySelectorAll<HTMLElement>(':scope > aside').forEach((aside) => {
      aside.hidden = preview
    })
  }

  page.addEventListener('click', (event) => {
    const button = (event.target as Element).closest<HTMLButtonElement>('button')
    if (!button) return
    if (button.dataset.previewPortfolioSection) {
      section = button.dataset.previewPortfolioSection
      render()
    }
    if (button.dataset.previewArtFilter) {
      artFilter = button.dataset.previewArtFilter
      render()
    }
    if (button.dataset.previewPortfolioView) {
      const editor = button.dataset.previewPortfolioView === 'editor'
      page.querySelector<HTMLElement>('[data-preview-portfolio-editor]')!.hidden = !editor
      page.querySelector<HTMLElement>('[data-preview-portfolio-projects]')!.hidden = editor
    }
    if (button.hasAttribute('data-preview-portfolio-preview')) {
      preview = !preview
      render()
    }
    if (button.hasAttribute('data-preview-portfolio-add')) {
      page.querySelector<HTMLElement>('[data-preview-portfolio-editor]')!.hidden = true
      page.querySelector<HTMLElement>('[data-preview-portfolio-projects]')!.hidden = false
    }
    if (button.dataset.previewPortfolioProject) {
      page.querySelector<HTMLElement>('[data-preview-portfolio-editor]')!.hidden = false
      page.querySelector<HTMLElement>('[data-preview-portfolio-projects]')!.hidden = true
      section = 'works'
      render()
      actions.report(`${button.dataset.previewPortfolioProject} added to your portfolio.`)
    }
  })
  form.addEventListener('input', (event) => {
    const input = event.target as HTMLInputElement
    data[input.name as PortfolioField] = input.value
    page.querySelector('[data-preview-portfolio-status]')!.textContent = 'Draft saved'
    render()
  })
  form.addEventListener('submit', (event) => {
    event.preventDefault()
    actions.report('Portfolio draft saved.')
  })
  return { render }
}
